// extracted by mini-css-extract-plugin
export default {"external":"aGmu2h","deprecatedBorderRadius":"bGmu2h","hasAnimation":"cGmu2h","container":"dGmu2h"};